import { CrmContactsRoutes } from "blackswan-api";

import { clearChatId } from "#app/api/middleware/websocketConnector";
import { ChatItemDTO, ChatContactDTO } from "#app/api/dto/chatDTO";

import { makeRequest } from "#app/components/Cabinet/Chat/ChatRequests";
import { sortContacts } from "#app/pages/Cabinet/utils/sortHelper";
import { Api } from "laravel-request";

export const chatRequest = (
    contacts: any[],
    data: { id: any },
    phones: (string | null)[],
    setContacts: (arg0: any) => void,
    setContactsLoaded: (arg0: boolean) => void,
    setContactsError?: (error: string | null) => void
) => {
    makeRequest({
        url: "chat/last",
        data: { phones },
        userId: data?.id,
        callback: (responseData: unknown): void => {
            const data = responseData as Record<string, unknown>;
            const uniqueContacts = getUniqueContacts(contacts, clearChatId);
            const chatDTOs = getChatItemsList(uniqueContacts, data, clearChatId);
            setContacts(sortContacts(chatDTOs));
            setContactsLoaded(true);
            if (setContactsError) {
                setContactsError(null);
            }
        },
        errorCallback: () => {
            // При ошибке устанавливаем флаг загрузки и ошибку
            setContactsLoaded(true);
            if (setContactsError) {
                setContactsError("Сервис чатов недоступен или контакты отсутствуют");
            }
        },
    });
};

const getUniqueContacts = (
    contacts: ChatContactDTO[],
    clearChatId: (phone: string | null) => string | null
): ChatContactDTO[] => {
    const seenPhones = new Set<string>();
    return contacts.filter((contact) => {
        const phone = clearChatId(contact.phone || "");
        if (phone && seenPhones.has(phone)) return false;
        phone && seenPhones.add(phone);
        return true;
    });
};

const getChatItemsList = (
    uniqueContacts: ChatContactDTO[],
    responseData: Record<string, unknown>,
    clearChatId: (phone: string | null) => string | null
): ChatItemDTO[] => {
    return uniqueContacts.map((contact) => {
        const phone = clearChatId(contact.phone || "");
        return ChatItemDTO.create(
            contact,
            phone,
            ((phone && responseData[phone]) as Record<string, unknown>) || {}
        );
    });
};

export const fetchContacts = (
    setContacts: (contacts: unknown[]) => void,
    setContactsLoaded: (loaded: boolean) => void,
    data: unknown,
    setContactsError?: (error: unknown) => void
) => {
    CrmContactsRoutes.index(
        (response: { data: any[] }) => {
            const contacts = response?.data ?? [];

            const phones = contacts
                .map((contact) =>
                    clearChatId(contact.phone && contact.phone !== "" ? contact.phone : "")
                )
                .filter((phone) => phone);
            chatRequest(
                contacts,
                data as { id: unknown },
                phones,
                setContacts,
                setContactsLoaded,
                setContactsError
            );
        },
        ["client"],
        {}
    );
};

/**
 * Тогглер переключения статуса клиента "В архиве"
 * @param contactId
 * @param isArchived
 * @param refuseReasonId
 */
export const setContactArchived = (
    contactId: number | string,
    isArchived: boolean | number,
    refuseReasonId: number = 1
) => {
    return Api.putArg("crm-contact", "archive", contactId, {
        is_archive: isArchived,
        refuse_reason_id: isArchived !== 0 ? refuseReasonId : null,
    });
};
